<template>
  <div class="bg-white rounded  my-4 shadow-md px-4 md:px-6 py-2 overflow-hidden mt-3">
    <h3 class="text-xl uppercase font-medium text-gray-800 tracking-wide">Přichází 2. polovina 19. století</h3>
    <h3 class="text-xl  font-medium text-blue-600">Povstání v roce 1848</h3>
    <p class="text-gray-800">
      Jak víte, Marie Terezie a Josef II. zlepšili život prostých lidí. Přesto byli <strong>Češi nespokojeni</strong>. Co žádali? 
      <ul class=" list-disc list-inside font-bold my-3">
        <li>zrušení roboty</li>
        <li>svobodný výběr náboženství</li>
        <li>zrovnoprávnění češtiny s němčinou</li>
        <li>konec neomezené vlády panovníka</li>
        <li>částečnu samostatnost českých zemí</li>
      </ul>
      Takže rakouská říše by zůstala zachována. České země by však měly své české úřady. Ty by rozhodovaly o naší zemi. Své požadavky Češi
      předložili panovníkovi. Ten slíbil, že většinu splní. K tomuto slibu ho donutila <strong>povstání</strong>, která začala
      <strong>na jaře roku <span class=" font-bold text-red-700">1848</span>  na mnoha místech rakouské říše</strong>.
    </p>
    <h3 class="text-xl  font-medium text-blue-600">Končí robota (v roce 1848)</h3>
    <p class="text-gray-800">
      Po porážce povstání <strong>vyhověl panovník habsburské říše jedinému požadavku vzbouřenců</strong>. Na podzim 
      <strong>roku 1848 zrušil poddanství</strong> a s ním spojenou <strong>robotu</strong>, takže z poddaných se stali
      <strong>svobodní lidé</strong>.
    </p>
    <p class="text-gray-800">
      Rolníci už <strong>nemuseli pracovat na polích svých panů</strong>. Mohli si <strong>koupit půdu</strong>, časem i nové 
      <strong>stroje poháněné parou</strong> (např. parní traktory). 
    </p>
    <p class="text-gray-800">Hodně nemajetných lidí z vesnic odešlo v této době pracovat <strong>do továren ve městech</strong>.</p>
    <h3 class="text-xl  font-medium text-blue-600">Roste tovární výroba</h3>
    <p class="text-gray-800">Zrušení roboty pomohlo <strong>rozvoji tovární výroby, podnikání</strong> i <strong>obchodu</strong>.
    <strong>České země</strong> se postupně staly <strong>hlavním střediskem průmyslové výroby v habsburské říši</strong>.
    </p>
    <p>Stavěly se tu <strong>nové továrny, pivovary, cukrovary, železniční tratě</strong>, otevíraly se <strong>uhelné doly</strong>. 
    Do celého světa jsme vyváželi např. pivo a cukr.
    </p>
    <div class="bg-yellow-400 p-4 rounded shadow-lg my-2">
      <p class="italic text-gray-800">Neznámějším českým strojírenským závodem se v této době staly Škodovy závody v Plzni, které založil Emil Škoda.
        Značka Škoda se používí i pro továrnu Škoda Auto v Mladé Boleslavi. Tu založili koncem 19. století dva mechanici. 
        Václav Laurin a Václav Klement. Zhruba po 20 letech došlo ke sloučení této továrny se Škodou Plzeň. Automobily zde 
        vyrobené nesou od té doby značku Škoda.
      </p>
    </div>
    <h3 class="text-xl  font-medium text-blue-600">Benzinové motory a elektřina</h3>
    <p class="text-gray-800">
      Ke konci 19. století dostal parní stroj konkurenci - <strong>benzinový motor</strong> <strong>elektřinu</strong>. 
      Nanašich silnicích se ojevila první auta dovezená z Německa. V roce 1897 byl na severní Moravě ve městě Kopřivnice
      vyroben <strong>první český automobil s benzinovým motorem</strong> nazvaný <strong>Präsident</strong>. 
    </p>
    <p>
      V továrnách, v dopravě i v domácnostech se začala zavádět <strong>elektřina</strong>. Ta byla mnohem <strong>výkonnější než pára</strong>. 
    </p>
    <div class="bg-yellow-400 p-4 rounded shadow-lg my-2">
      <p class="italic text-gray-800">
        Velkou zásluhu na zavádění elektrické energie v českých zemích měl český podnikatel a vynálezce František Křižík. Jeho 
        nejznámějšívynález je oblouková lampa (předchůdkyně dnešní žárovky). V roce 1903 vybudoval první elektrifikovanou železnici 
        v Rakousku-Uhersku (vedla z Tábora do Bechyně).
      </p>
    </div>
    <h3 class="text-xl  font-medium text-blue-600">Rozvoj měst</h3>
    <p class="text-gray-800">
      Ve městech přibývalo obyvatel, protože do továren přicházelo pracovat mnoho lidí z venkova. Ti museli někde bydlet. 
      Stavěly se pro ně <strong>pavlačové domy</strong> s malými byty a několikapatrové nájemní <strong>činžovní domy</strong>, 
      tzv. činžáky
    </p>
    <p class="text-gray-800"> 
      Bohatí lidé bydleli v <strong>rodinných domech</strong> nebo ve velkých, <strong>několikapokojových bytech</strong> s koupelnou
      a toaletou.
    </p>
     <p class="text-gray-800"> 
      Stavěly se také nové školy, nádraží, trřnice. Dláždily se ulice, zavádělo se veřejné plynové osvětlení, vodovody, kanalizace.
    </p>
    <h3 class="text-xl  font-medium text-blue-600">Delší povinná školní docházka</h3>
    <p class="text-gray-800">
     Ve 2. polovině 19. století <strong>se povinná školní docházka prodloužila na 8 let. </strong> <strong>Děti</strong> tak 
     <strong>povinně</strong> chodily <strong>do školy od šesti do čtrnácti let</strong>. (Další vzdělání bylo nepovinné.)
     Díky tomuto opatření uměli koncem 19. století téměř všichni lidé v českých zemích číst, psát a počítat.
    </p>
    <h3 class="text-xl  font-medium text-blue-600">Nejdéle vládnoucí Habsburk</h3>
    <p class="text-gray-800">
     Po revoluci v roce 1848 se stal <strong>rakouským císařem</strong> a <strong>českým králem František Josef I.</strong>. Omezil
     svobodu lidí a nařídil policejní sledování těch, kdo kritizovali jeho vládu. <strong>Ve školách</strong> i <strong>na úřadech</strong> se 
     muselo povinně mluvit <strong>německy</strong>. Nespokojenost lidí donutila Františka Josefa k tomu, že časem změnil způsob vlády. 
     <strong>Vydal ústavu</strong>, která zaručovala základní práva občanů. Tím skončila jeho neomezená vláda.
    </p>
    <div class="bg-yellow-400 p-4 rounded shadow-lg my-2">
      <p class="italic text-gray-800">
        František Josef I. se stal panovníkem habsburské říše ve svých 18 letech. Vládl nejdéle ze všech Habsburků - téměř 68 let.
        Byl pracovitý, vstával v 5 hodin ráno, uléhal ve 21 hodin.
      </p>
    </div>
    <h3 class="text-xl  font-medium text-blue-600">Změna názvu říše</h3>
    <p class="text-gray-800">
      Jak víte, habsburská říše se skládala <strong>z více zemí</strong>. Jedna z nich si vymohla ve 2. polovině 19. století
      na panovníkovi <strong>částečnou samostatnost</strong>. Bylo to <strong>Uhersko</strong> (dnešní Maďarsko).
    </p>
    <p class="text-gray-800">
     Říše se tak rozdělila na dvě rovnoprávné, ale ne úplně samostatné části. Jednou částí bylo Rakousko, druhou Uhry. 
     Proto se změnil název říše na <strong>Rakousko-Uhersko</strong>.
    </p>
    <p class="text-gray-800">
     <strong>Našim zemím se</strong> v 2. polovině 19. století <strong>nepodařilo získat částečnou samostanost</strong>. 
     V této době <strong>patřily k Rakousku</strong>.
    </p>
    <h3 class="text-xl  font-medium text-blue-600">Tomáš Garrigue Masaryk</h3>
    <p class="text-gray-800">
      <strong>Někteří naši politici</strong> usilovali v této době <strong>o částečné osamostatnění českých zemí</strong>. 
      To znamená, že bychom dále patřili k Rakousku-Uhersku, ale už by  nás nerozhodovala vídeňská vláda, ale vláda česká. 
      Tento náor zprvu zastával i vysokoškolský profesor <strong>Tomáš Garrigue</strong> [garik] <strong>Masaryk</strong>
      - náš budoucí prezident. <strong>Později</strong> však svůj názor změnil a <strong>začal bojovat za samostaný český stát</strong>.
    </p>
    <div class="bg-yellow-400 p-4 rounded shadow-lg my-2">
      <p class="italic text-gray-800">
        Tomáš Garrigue Masaryk měl dvě příjmení. Ke svému rodnému příjmení Masaryk přidal ještě příjmení své manželky Charlotty, 
        která pocházela z USA.
      </p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>